import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import ApiClient from "../../lib/apiClient";
import FieldSchemaApiClient from "./fieldSchemaApiClient";
import { SchemaFactoryV2 } from "./useFieldSchemaV2";

interface FieldSchemaV2FactoryContextProps {
  schemaFactory?: SchemaFactoryV2;
  isLoading: boolean;
}

interface FieldSchemaV2FactoryProviderProps {
  children: ReactNode;
  apiClient: ApiClient;
}

const FieldSchemaV2FactoryContext = createContext<FieldSchemaV2FactoryContextProps>({
  schemaFactory: undefined,
  isLoading: false,
});

export const FieldSchemaV2FactoryProvider: React.FC<FieldSchemaV2FactoryProviderProps> = ({
  children,
  apiClient,
}) => {
  const [schemaFactory, setSchemaFactory] = useState<SchemaFactoryV2>();
  const [isLoading, setIsLoading] = useState(false);

  const initializeSchemaFactory = async () => {
    setIsLoading(true);
    const fieldSchemaApiClient = new FieldSchemaApiClient(apiClient);
    const schema = await fieldSchemaApiClient.getSchemaV2();
    const newSchemaFactory = new SchemaFactoryV2(schema);
    setSchemaFactory(newSchemaFactory);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!schemaFactory) {
      initializeSchemaFactory();
    }
  }, []);

  return (
    <FieldSchemaV2FactoryContext.Provider
      value={{
        schemaFactory,
        isLoading,
      }}
    >
      {children}
    </FieldSchemaV2FactoryContext.Provider>
  );
};

export const useFieldSchemaV2FactoryContext = () => useContext(FieldSchemaV2FactoryContext); 